// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
            .help-block {
                font-size: small;
            }
        `, "",{"version":3,"sources":["webpack://./src/gamma/form/formquestionerror-bootstrap/formquestionerror-bootstrap.component.ts"],"names":[],"mappings":";YACY;gBACI,gBAAgB;YACpB","sourcesContent":["\n            .help-block {\n                font-size: small;\n            }\n        "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
